import styled from 'styled-components';
import { HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS } from 'common/components/TouchpointEditor/components/TouchpointContainer'; // eslint-disable-line max-len

export const LeftAlignedSessionTextContainer = styled.div`
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
    text-align: left;
`;
